<template>
  <div class="brand-page">
    <b-tabs
      v-if="isLoaded"
      class="collection-tabs"
      nav-wrapper-class="collection-list"
    >
      <b-tab title="Active Collections">
        <div v-if="liveCollections.length">
          <section class="brand-collections">
            <collection-card
              v-for="collection in liveCollections"
              :key="collection._id"
              :collection="collection"
            />
          </section>
        </div>
        <div v-else>
          <div class="mt-md-5">
            <div class="empty-icon-bg collection mb-1">
              <message-icon />
            </div>
            <b-card-text
              class="color-sonic-silver"
            >The brand doesn’t have any active collections. You’ll get <br>
              notification, when the brand uploaded the new one.
            </b-card-text>
          </div>
        </div>
      </b-tab>
      <b-tab title="Previous Collections">
        <div v-if="previousCollections.length">
          <section class="brand-collections">
            <collection-card
              v-for="collection in previousCollections"
              :key="collection._id"
              :is-previous-collection="true"
              :collection="collection"
            />
          </section>
        </div>
        <div v-else>
          <div class="mt-md-5">
            <div class="empty-icon-bg collection mb-1">
              <message-icon-2 />
            </div>
            <b-card-text
              class="color-sonic-silver"
            >This brand doesn’t have any previous collections.
            </b-card-text>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <div
      v-else
      class="elements-center p-5 w-100"
    >
      <b-spinner />
    </div>
  </div>
</template>

<script>
import {
 BTabs, BTab, BSpinner, BCardText,
} from 'bootstrap-vue'
import MessageIcon from '@/@core/assets/svg-components/MessageIcon.vue'
import MessageIcon2 from '@/@core/assets/svg-components/MessageIcon2.vue'
import { useBrandDetail } from '@/composables/useBrandDetail'
import CollectionCard from './CollectionCard.vue'

export default {
  components: {
    BTabs,
    BTab,
    BSpinner,
    BCardText,
    CollectionCard,
    MessageIcon,
    MessageIcon2,
  },
  setup() {
    const {
      liveCollections,
      previousCollections,
      collectionsLoaded,
      fetchCollections,
    } = useBrandDetail()

    return {
      liveCollections,
      previousCollections,
      isLoaded: collectionsLoaded,
      fetchCollections,
    }
  },
  data() {
    return {
      brandId: this.$route?.params?.brandId,
    }
  },
  watch: {
    '$route.params.brandId': {
      handler(brandId) {
        if (brandId !== this.brandId) {
          this.brandId = brandId
          this.fetchCollections(this.brandId)
        }
      },
      immediate: true,
    },
  },
  created() {
    this.fetchCollections(this.brandId)
  },
}
</script>
